import React from 'react';

const YouAreLost = () => {
    return (
        <div>Ups, falsch abgebogen. <a href='/'>Hier geht's zurück.</a></div>
    )
}

export default YouAreLost;